import React, { useState } from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './TemplatePreview.module.css';
import isMobile from 'is-mobile';
import { useDispatch } from 'react-redux';
import { designActions } from '../../actions';
import _ from 'lodash';
import { Button } from 'semantic-ui-react';

const TemplatePreview = props => {
  const { template } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [mainImage, setMainImage] = useState(`${template.data.id}/thumbnail_large.png`);
  const pages = _.get(template, 'data.pages', []).map((value, index) => (
    <img
      alt=""
      key={index}
      src={`${process.env.REACT_APP_FILE_SERVER}/resources/templates/${template.data.id}-${index +
        1}/thumbnail_large.png`}
    />
  ));
  const ArrowLeft = <Button circular icon="angle right" />;
  const ArrowRight = <Button circular icon="angle left" />;

  const createDesign = () => {
    dispatch(
      designActions.create({
        templateId: _.get(template, 'data.id'),
        templateCategory: _.get(template, 'data.categories', [''])[0],
      }),
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.template}>
          <div className={styles.preview}>
            <img alt="" src={`${process.env.REACT_APP_FILE_SERVER}/resources/templates/${mainImage}`} />
          </div>
          {pages && pages.length > 1 && (
            <div className={styles.pages}>
              <ScrollMenu
                data={pages}
                arrowLeft={ArrowLeft}
                arrowRight={ArrowRight}
                alignCenter={false}
                hideSingleArrow={true}
                hideArrows={false}
                dragging={isMobile()}
                rtl={document.documentElement.dir === 'rtl'}
                wheel={false}
                onSelect={index => setMainImage(`${template.data.id}-${parseInt(index) + 1}/thumbnail_large.png`)}
              />
            </div>
          )}
        </div>
        <div className={styles.information}>
          <div className={styles.name}>{template.data.name}</div>
          <div>
            {`${t(template.data.categories[0])} ${template.data.size.width}x${template.data.size.height} ${t('pixel')}`}
          </div>
          <Button content={t('useTemplate')} onClick={createDesign} />
        </div>
      </div>
      <div className={styles.footer}></div>
    </div>
  );
};

TemplatePreview.propTypes = {
  template: PropTypes.object,
  modal: PropTypes.bool,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default TemplatePreview;
